import { Component, ViewContainerRef, } from '@angular/core';
import { MdDialog } from '@angular/material';

import { Vacuna, Dosis, } from '../../../../models';
import { TdDialogService } from '@covalent/core';

@Component({
  selector: 'qs-detallevacunas',
  templateUrl: './detallevacunas.component.html',
})

export class VacunasDetalleComponent {

  public vacuna: Vacuna;

  constructor(private _dialogService: TdDialogService) { }

  close(): void {
    this._dialogService.closeAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/vacunas/detallevacunas/detallevacunas.component.ts